import React from 'react'
import "./mobileSoon.css";
import { useTranslation } from 'react-i18next';



const MobileComingSoon = props => {

  const { t } = useTranslation();
  const { currentUrl } = props;
  let link = null;
  if (currentUrl.includes('sk')) {
    link = 'https://api.tastescanvote.com/pdf/SK_WINNERS_LAYS%20NCP.pdf'
  } else if (currentUrl.includes('hu')) {
    link = 'https://api.tastescanvote.com/pdf/HU_WINNERS_LAYS%20NCP.pdf'
  } else {
    link = 'https://api.tastescanvote.com/pdf/CZ_WINNERS_LAYS%20NCP.pdf'
  }

  return (
    <div className="mobileComingSoon">

      <div>
        <div className="text text2">{t('soonPage1')}</div>
        <div className="text text2">{t('soonPage2')}</div>
        <div className="text text3">{t('soonPage3')} <a href={link} target='_blank'>{t('soonPage4')}</a> </div>
      </div>

    </div>
  )
}

export default MobileComingSoon